import { Component } from "@angular/core";
import {
    FormBuilder,
    FormGroup,
    Validators,
    ReactiveFormsModule,
} from "@angular/forms";
import { Router, RouterLink } from "@angular/router";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatIconModule } from "@angular/material/icon";
import { MatCheckboxModule } from "@angular/material/checkbox";

import { AuthService } from "../../../core/services/auth.service";

@Component({
    selector: "app-login",
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatIconModule,
        MatCheckboxModule,
        RouterLink,
    ],
    templateUrl: "./login.html",
    styleUrls: ["./login.scss"],
})
export class LoginComponent {
    loginForm: FormGroup;
    error: string = "";
    loading: boolean = false;
    hidePassword = true;
    currentYear: number = new Date().getFullYear();

    constructor(
        private fb: FormBuilder,
        private authService: AuthService,
        private router: Router
    ) {
        this.loginForm = this.fb.group({
            email: ["", [Validators.required, Validators.email]],
            password: ["", [Validators.required, Validators.minLength(6)]],
        });
    }

    onSubmit(): void {
        if (this.loginForm.valid) {
            this.loading = true;
            this.error = "";

            this.authService.login(this.loginForm.value).subscribe({
                next: (response) => {
                    if (this.authService.isAdmin()) {
                        this.router.navigate(["/dashboard/admin/entities"]);
                    } else if (response.requires_entity_creation) {
                        this.router.navigate(["/auth/create-entity"]);
                    } else {
                        this.router.navigate(["/dashboard/groups"]);
                    }
                },
                error: (err) => {
                    // Handle different error types
                    if (err.type === 'invalid_credentials') {
                        // 401 - Invalid credentials (user doesn't exist or wrong password)
                        this.error = err.message || "Invalid email or password. Please check your credentials and try again.";
                    } else if (err.type === 'unverified_email') {
                        // 403 - Unverified email (backend automatically sends verification email)
                        this.error = err.message || "Your email address has not been verified. A verification email has been sent to your inbox. Please check your email and click the verification link to activate your account.";
                    } else {
                        // Other errors
                        this.error = err.message || "An error occurred during login. Please try again later.";
                    }
                    this.loading = false;
                },
            });
        }
    }
}
